export const extractDateFromString = (inputString) => {
  const result = inputString
    .replace("https://vizio.atafreight.com/ImpexCoreDev/Invoice/Invoice", "")
    .split("_")[0];
  var date = "";
  var month = "";
  var year = "";
  for (const char of result.split("")) {
    if (date.length < 2 && !isNaN(char)) {
      date += char;
    } else if (isNaN(char)) {
      month += char;
    } else if (year.length < 4 && !isNaN(char)) {
      year += char;
    }
  }

  return date + "-" + month + "-" + year;
};

export const poDataCreator = (poList) => {
  const updatedList = [];

  for (const po of poList) {
    const commonData = {
      BCCMail:po.BCCMail,
      CCMail:po.CCMail,
      POID: po.POID,
      PONumber: po.PONumber,
      PODate: po.PODate,
      POType: po.POType,
      Supplier: po.Supplier,
      Customer: po.Customer,
      PaymentTerms: po.PaymentTerms,
      DeliveryTerms: po.DeliveryTerms,
      PO_Status: po.PO_Status,
      Remarks: po.Remarks,
      FTPLink: po.FTPLink,
      duedate: po.duedate,
      LatestAction: po.LatestAction,
      PendingQTY: po.PendingQTY,
      IsInvoiceGenerated: po.IsInvoiceGenerated,
      SupplierEmails: po.SupplierEmails,
      SupplierShortName:po.SupplierShortName
    };
    const updatedSubRows = [];
    const partCombined = [];
    po.subRows.forEach((item) => {
      partCombined.push(item.PartNo);
      updatedSubRows.push({
        PartNo: item.PartNo,
        QTY: item.Qty,
        ...commonData,
        PendingQTY: item.PendingQty,
      });
    });

    updatedList.push({
      ...commonData,
      QTY: po.QTY,
      PartNo: partCombined,
      subRows: updatedSubRows,
    });
  }

  return updatedList;
};

export const poDataExcelCreator = (poList) => {
  const updatedList = [];

  for (const po of poList) {
    const commonData = {
      POID: po.POID,
      PONumber: po.PONumber,
      PODate: po.PODate,
      POType: po.POType,
      Supplier: po.Supplier,
      Customer: po.Customer,
      PaymentTerms: po.PaymentTerms,
      DeliveryTerms: po.DeliveryTerms,
      PO_Status: po.PO_Status,
      Remarks: po.Remarks,
      FTPLink: po.FTPLink,
      duedate: po.duedate,
      LatestAction: po.LatestAction,
      PendingQTY: po.PendingQTY,
      IsInvoiceGenerated: po.IsInvoiceGenerated,
    };
    // below code commented to show parent row if required in future
    // if (po.subRows.length > 1) {
    //   const updatedSubRows = [];
    //   const partCombined = [];
    //   po.subRows.forEach((item) => {
    //     partCombined.push(item.PartNo);
    //     updatedSubRows.push({
    //       PartNo: item.PartNo,
    //       QTY: item.Qty,
    //       ...commonData,
    //       PendingQTY: item.PendingQty,
    //     });
    //   });

    //   updatedList.push({
    //     ...commonData,
    //     QTY: po.QTY,
    //     PartNo: partCombined,
    //     subRows: updatedSubRows,
    //   });
    // }
    po.subRows.forEach((item) => {
      updatedList.push({
        PartNo: item.PartNo,
        QTY: item.Qty,
        ...commonData,
        PendingQTY: item.PendingQty,
        subRows: [],
      });
    });
  }
  return updatedList;
};

export const invoiceDataCreator = (invoiceData) => {
  return invoiceData.map((item) => {
    return {
      ...item,
      PartNo: item.subRows.map((row) => row.PartNo),
      subRows: item.subRows.map((row) => {
        return {
          ...row,
          Supplier: item.Supplier,
          PODate: item.PODate,
          duedate: item.duedate,
        };
      }),
    };
  });
};
